import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AddPathologyRes;
export const AddPathologyTodo = createAsyncThunk('AddPathology', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'superadmin/company_master',
            data: data,
            headers: { "Content-Type": "multipart/form-data",  "Authorization": 'Bearer ' + localStorage.getItem('user_token')}
        })
        return AddPathologyRes = res.data
        
    } catch (error) {
        return AddPathologyRes = error.response.data
    }
})